import { forwardRef, type Ref } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import { resolveBaseAppearance } from './theme';
import type { BaseCodeProps } from './types';
import { cn } from './utils';

export const BaseCode = forwardRef<HTMLElement, BaseCodeProps>(function BaseCode(
  {
    children,
    display = 'inline',
    appearance,
    className,
    classNames,
    style,
    ...codeProps
  },
  ref,
) {
  const resolvedAppearance = useMonkeysBaseAppearance(appearance);
  const componentAttributes = useMonkeysComponentAttributes();
  const theme = resolveBaseAppearance(resolvedAppearance);

  if (display === 'block') {
    return (
      <pre
        {...componentAttributes}
        {...codeProps}
        ref={ref as Ref<HTMLPreElement>}
        data-monkeys-component="code"
        data-slot="root"
        data-display="block"
        className={cn(theme.slots.codeBlock, classNames?.root, className)}
        style={{
          ...theme.styles.code,
          ...style,
        }}
      >
        <code
          data-slot="code"
          className={cn(theme.slots.codeContent, classNames?.code)}
          style={theme.styles.codeContent}
        >
          {children}
        </code>
      </pre>
    );
  }

  return (
    <code
      {...componentAttributes}
      {...codeProps}
      ref={ref as Ref<HTMLElement>}
      data-monkeys-component="code"
      data-slot="root"
      data-display="inline"
      className={cn(
        theme.slots.codeInline,
        theme.slots.codeContent,
        classNames?.root,
        classNames?.code,
        className,
      )}
      style={{
        ...theme.styles.code,
        ...theme.styles.codeContent,
        ...style,
      }}
    >
      {children}
    </code>
  );
});
